export default function MobileFilterTrigger() {
	// Cache frequently accessed elements
	const openFilters = document.querySelector('.js-open-filters');
	const filterContent = openFilters ? openFilters.nextElementSibling : null;

	// Attach event listeners
	if (openFilters && filterContent) {
		openFilters.addEventListener('click', handleFiltersToggle);
	}

	const filtersContainer = document.querySelector('.js-filters-container');

	if (filtersContainer) {
		filtersContainer.addEventListener('change', handleFilterChange);
	}

	function handleFiltersToggle(e) {
		e.preventDefault();

		const filterContent = (e.target.tagName.toLowerCase() === 'div') ? e.target.nextElementSibling : e.target.closest('div').nextElementSibling;

		filterContent.classList.toggle('hidden');
	}

	function handleFilterChange(e) {
		const filter = e.target;
		const form = filter.closest('form');
		if (form) {
			form.submit();
		}
	}
}
